import React from 'react';
import { motion } from 'framer-motion';
import { ScrollButton } from './Shared';
export const Hero = () => {
  return <section className="relative overflow-hidden" data-id="element-79">
      <div className="max-w-2xl mx-auto px-5 sm:px-6 lg:px-8 h-[100svh] sm:h-auto flex flex-col justify-center py-4 sm:pt-16 sm:pb-16" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center w-full flex flex-col min-h-0 flex-1 sm:block sm:flex-none" data-id="element-81">
          {/* Headline */}
          <h1 className="text-[26px] leading-[1.1] sm:text-5xl md:text-6xl font-serif font-bold text-brand-charcoal sm:leading-[1.05] mb-2 sm:mb-6 flex-shrink-0" data-id="element-82">
            Resuelve un año entero de clases de Pilates en solo{' '}
            <span className="italic text-brand-terracotta" data-id="element-83">5 minutos</span>
          </h1>

          {/* Subheadline */}
          <p className="text-xs sm:text-lg text-gray-600 leading-snug sm:leading-relaxed mb-3 sm:mb-8 max-w-xl mx-auto px-2 flex-shrink-0" data-id="element-84">
            Más de 1.200 profesoras ya dejaron de improvisar. Llega a cada clase
            con todo listo para enseñar, profundizar y transformar.
          </p>

          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="flex-1 min-h-0 flex items-center justify-center mb-3 sm:mb-10 sm:flex-none sm:block" data-id="element-85">
            <img src="https://cdn.magicpatterns.com/uploads/3oxp5TZezgsFi5fjcJ7ZWn/52.png" alt="Megapack Pilates 360" loading="eager" fetchPriority="high" decoding="async" width="600" height="600" className="h-full w-auto max-h-full object-contain mx-auto sm:h-auto sm:w-full sm:max-w-md" data-id="element-86" />
          </motion.div>

          {/* CTA */}
          <div className="flex-shrink-0" data-id="element-87">
            <ScrollButton className="w-full sm:w-auto bg-brand-terracotta hover:bg-brand-terracotta-dark text-white text-sm sm:text-lg font-bold py-4 px-10 sm:px-14 rounded-full shadow-lg shadow-brand-terracotta/30 transition-all transform hover:-translate-y-0.5 inline-flex items-center justify-center gap-2" data-id="element-88">
              QUIERO EL KIT PILATES 360
            </ScrollButton>

            {/* Trust Line */}
            <div className="mt-3 sm:mt-6 flex flex-wrap justify-center items-center gap-x-2 gap-y-1 sm:gap-x-3 text-[11px] sm:text-sm font-medium text-gray-600" data-id="element-89">
              <span data-id="element-90">Descarga inmediata</span>
              <span className="text-gray-300" data-id="element-91">·</span>
              <span data-id="element-92">Sin suscripción</span>
              <span className="text-gray-300" data-id="element-93">·</span>
              <span data-id="element-94">Acceso de por vida</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};